import { render, staticRenderFns } from "./AuthPos.vue?vue&type=template&id=4d1cce66&"
import script from "./AuthPos.vue?vue&type=script&lang=js&"
export * from "./AuthPos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports